import { folderInfoFrag } from '../../../utils/type/folder.common-type';
import { userInfoFrag } from '../../../utils/type/user.common-type';

export const getIndividualPlansFrag = `
    id
    folderId
    folder {
        ${folderInfoFrag}
    }
    revisionDate
    contractEndDate
    deadlineDate
    deadlineType
    revisionUser {
        ${userInfoFrag}
    }
`;
